import * as actions from '../../ActionsConst';
import helpers from './Helpers';
import { getDefaultProductSettings } from './settings/SettingsHelpers';

const products = (state = getDefaultProductSettings(), action) => {
  switch (action.type) {
    case actions.PRODUCT_SETTINGS:
      return helpers.buildUpdateSettings(state, action);
    case actions.PRODUCT_SELECT_ALL:
      return helpers.buildUpdateSettings(state, { newSettings: { selectAll: true } });
    case actions.PRODUCT_DESELECT_ALL:
      return helpers.buildUpdateSettings(state, { newSettings: { selectAll: false } });
    case actions.RESET_PRODUCT_SETTINGS:
      return helpers.resetProductSettings();
    default:
      return state;
  }
};

export default products;
